<template>
  <div class="UST-container">
    <header>View</header>
    <div class='article' id="USTView">
      <USTSideView v-if="!throwError" :manImgHeight="manImgHeight" ref="USTSideView" :screenStatus="screenStatus" :boardStatus="boardStatus" :pjImgType="pjImgType" :wallPlateH="wallPlateH"></USTSideView>
      <USTFrontView v-if="!throwError" :manImgHeight="manImgHeight" ref="USTFrontView" :screenStatus="screenStatus" :boardStatus="boardStatus" :pjImgType="pjImgType" :wallPlateH="wallPlateH" :isScreenDrag="isScreenDrag"></USTFrontView>
      <div class="throwError" v-else>{{ $t('T_MESSAGE1_WHITEBOARD') }}</div>
    </div>
    <footer>
      <ResultInformationButton></ResultInformationButton>
    </footer>
  </div>
</template>

<script>
import USTSideView from './USTSideView'
import USTFrontView from './USTFrontView'
import { mapState, mapMutations } from 'vuex'
import ResultInformationButton from '@/view/result/resultInformationButton'

export default {
  name: 'USTViewIndex',
  components: { USTSideView, USTFrontView, ResultInformationButton },
  data () {
    return {
      ceilingHFixed: 600, // 图中房间高度 固定为600px
      ceilingWFixed: 620, // 图中房间宽度 固定为620px
      mamHeight: 180,
      LatviaCode: ['H919', 'H921', 'H923'],
      screenStatus: {
        height: 0,
        top: 0
      },
      boardStatus: {
        width: 0,
        height: 0
      },
      isScreenDrag: false
    }
  },
  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'USTPjTop',
      'selectedModelData',
      'drawData',
      'offset',
      'isUSTWall',
      'selectedLensData',
      'throwDistanceChecked',
      'whiteboardStatus',
      'throwError'
    ]),
    manImgHeight () {
      let height = (this.ceilingHFixed * this.mamHeight) / this.houseInfo.roomH
      return height > this.ceilingHFixed ? this.ceilingHFixed : height
    },
    isLatvia () {
      return this.LatviaCode.indexOf(this.selectedModelData.code) !== -1
    },
    pjImgType () {
      return this.isLatvia ? 'P2' : 'P1'
    },
    wallPlateH () { // 画面中实际表示的像素
      return this.isLatvia ? 58 : 55
    },
    pjZMin () {
      return this.selectedModelData.wallHeight / 10 - this.selectedLensData.mpts2wallBottomHeight + this.selectedLensData.lens2mptsHeight
    },
    pjZMax () {
      return this.houseInfo.roomH
    },
    wallPlateHeight () { // 画面中应该表示的像素
      let value = this.ceilingHFixed * this.pjZMin / this.houseInfo.roomH
      return value
    }
  },
  watch: {
    drawData: {
      handler (val) {
        let screenPArr = val[0]
        let screenH = screenPArr[3].z - screenPArr[0].z
        let height = (this.ceilingHFixed * screenH) / this.houseInfo.roomH
        let top = (screenPArr[0].z * this.ceilingHFixed) / this.houseInfo.roomH > this.ceilingHFixed ? this.ceilingHFixed : (screenPArr[0].z * this.ceilingHFixed) / this.houseInfo.roomH
        this.screenStatus = {height, top}
        if (this.whiteboardStatus) {
          this.boardStatus.width = (this.ceilingHFixed * this.graph.boardW) / this.houseInfo.roomH
          this.boardStatus.width = this.boardStatus.width > this.ceilingWFixed ? this.ceilingWFixed : this.boardStatus.width
          this.boardStatus.height = (this.ceilingHFixed * this.graph.boardH) / this.houseInfo.roomH
          if (!this.throwDistanceChecked) this.$commonJs.getBoardTop()
        }
        this.setInitPosition()
      }
    },
    isUSTWall: {
      handler (val) {
        if (val && this.offset > 10) {
          this.SET_OFFSET(10)
        }
      },
      immediate: true
    },
    selectedModelData () {
      this.PJZ(this.pjZMin)
    }
  },
  methods: {
    ...mapMutations(['SET_USTPJTOP', 'PJX', 'PJZ', 'SET_OFFSET', 'SET_VLENSSHIFT']),
    setInitPosition (status) {
      let pjZVal = this.graph.pjZ
      // value
      let wallPlateTop = pjZVal - this.selectedLensData.lens2mptsHeight + this.selectedLensData.mpts2wallBottomHeight - this.selectedModelData.wallHeight / 10
      // px
      let wallPlateTopVal = wallPlateTop * this.ceilingHFixed / this.houseInfo.roomH
      if (status || wallPlateTopVal <= 0) {
        wallPlateTopVal = 0
        this.PJZ(this.pjZMin)
      } else if (wallPlateTopVal >= this.ceilingHFixed - this.wallPlateH) {
        wallPlateTopVal = this.ceilingHFixed - this.wallPlateH
        this.PJZ(this.pjZMax)
      }
      this.PJX(this.houseInfo.roomW / 2)
      this.SET_USTPJTOP(wallPlateTopVal)
      if (this.$refs['USTSideView']) this.$refs['USTSideView'].setPosition()
    }
  },
  mounted () {
    this.$on('screenDrag', function (val) {
      this.isScreenDrag = val
    })
    // 初始化时 wallPlateToCeiling 至为0
    this.setInitPosition(true)
    // 为超短焦设置默认vlens shift
    let data = this.selectedLensData
    let defaultRatio = data.lcd.aspectRatio
    let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(defaultRatio, data)
    if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
      let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
      let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
      let res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
      this.SET_VLENSSHIFT(res * 100 * -1)
    }
  }
}
</script>
<style scoped>
.UST-container {
  height: 960px;
}
header {
  height: 31px;
  background: #bbb;
  border-top: 2px solid #bdbdbd;
  border-right: 2px solid #bdbdbd;
  margin-top: -1px;
  margin-right: -1px;
  padding-left: 10px;
  line-height: 31px;
  font-weight: 700;
  font-size: 14px;
}
.article {
  background: url("../../../assets/parts/UST/wall.png") no-repeat;
  background-size: 932px 856px;
  height: 856px;
  position: relative;
  overflow: hidden;
}
footer {
  height: 70px;
  border-top: 1px solid #a3a3a2;
  background: #afafb0;
}
.throwError {
  position: relative;
  top: 300px;
  left: 350px;
  width: 300px;
  padding: 10px;
  background-color: #ffffff;
  border: 3px solid #385d8a;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/UST/USTViewIndex.vue